import { Container, Notice, Separator } from 'telia-front-react';
import { BrowserHistory } from 'history';
import { observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from '../util/RouteHelper';

interface ComponentErrorBoundaryProps {
  messageKey?: string;
  history: BrowserHistory;
  children: React.ReactNode;
}
interface ComponentErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

const ComponentErrorBoundary = observer(
  class ComponentErrorBoundary extends React.Component<ComponentErrorBoundaryProps> {
    public state: ComponentErrorBoundaryState = {
      hasError: false,
      error: null,
    };

    constructor(props: ComponentErrorBoundaryProps) {
      super(props);

      props.history.listen(() => {
        if (this.state.hasError) {
          this.setState({
            hasError: false,
          });
        }
      });
    }

    public componentDidCatch(error: Error | null) {
      this.setState({ hasError: true, error });
    }

    public render() {
      if (this.state.hasError) {
        return (
          <Container>
            <Separator spacing="large" color="invisible" />
            <Notice type="error">
              <b>Error</b>
              {this.state.error && this.renderError()}
            </Notice>
            <Separator spacing="large" color="invisible" />
          </Container>
        );
      }
      return this.props.children;
    }

    private renderError(): React.JSX.Element {
      return (
        <>
          <br />
          {this.state.error?.stack}
        </>
      );
    }
  },
);

export default withRouter(ComponentErrorBoundary);
